import { Col, Row, Alert } from 'antd';
import React, { useEffect, useState } from 'react';
import './Vallet.scss';
import ProposalsList from '../../components/Vallet/ProposalsList';
import ProposalsCountCard from '../../components/Vallet/ProposalsCountCard';
import ContractCountCard from '../../components/Vallet/ContractCountCard';
import RenuewCard from '../../components/Vallet/RenuewCard';
import EarningsPerTransactionCard from '../../components/Vallet/EarningsPerTransactionCard';
import { hasRole } from '../../utils';
import UserService from '../../services/UserService';


const Vallet = () => {

  const [isAdmin, setIsAdmin] = useState(false);
  const [isCentralUser, setIsCentralUser] = useState(false);
  const [showIdentityWarn, setShowIdentityWarn] = useState(false);

  useEffect(() => {
    const isUserAdmin = hasRole('ADMIN');
    setIsAdmin(isUserAdmin);

    const isUserCentralUser = hasRole('CENTRAL_USER');
    setIsCentralUser(isUserCentralUser);

    // CUSTOMER kimlik belgesi kontrolü
    const isCustomer = hasRole('CUSTOMER');
    if (isCustomer && !isUserAdmin && !isUserCentralUser) {
      UserService.getMe()
        .then((res: any) => {
          const url = res?.data?.identityDocumentUrl;
          if (!url) setShowIdentityWarn(true);
        })
        .catch(() => { /* sessiz geç */ });
    }
  }, [])

  return (
    (isAdmin || isCentralUser) ? <h2 className="text-center">Sayfaya erişiminiz yoktur</h2> : <div className='p-20px vallet ' style={{ marginBottom: 120 }}>
      {showIdentityWarn && (
        <Alert
          type='warning'
          showIcon
          message='Profil sayfasında belgeler kısmından nüfus cüzlanınızı yüklemeniz gerekiyor, yüklemediğiniz takdirde hakediş ödeme işlemi yapılamaz.'
          style={{ marginBottom: 16 }}
        />
      )}
      <Row gutter={[16, 16]}>
        <Col lg={6} md={12} xs={24}>
          <EarningsPerTransactionCard />
        </Col>

        <Col lg={6} md={12} xs={24}>
          <ProposalsCountCard />
        </Col>

        <Col lg={6} md={24} xs={24}>
          <ContractCountCard />
        </Col>
        <Col lg={6} md={24} xs={24} className="vallet-page">
          <RenuewCard />
        </Col>
      </Row>
      <ProposalsList />
    </div>
  );
};

export default Vallet;
